import { render, staticRenderFns } from "./cta-button-cmp.vue?vue&type=template&id=2715dd76&scoped=true"
import script from "./cta-button-cmp.vue?vue&type=script&lang=js"
export * from "./cta-button-cmp.vue?vue&type=script&lang=js"
import style0 from "./cta-button-cmp.vue?vue&type=style&index=0&id=2715dd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715dd76",
  null
  
)

export default component.exports